"use strict"

import SCH from './classes/SCH'

const sch = SCH.Instance

window.sch = sch


export {
   sch as default,
}
